import ClientDomainStore from "../../stores/ClientDomainStore";
import ClientWebsiteStore from "../../stores/ClientWebsiteStore";
import UserStore from '../../stores/UserStore';

import React from 'react';
import { TabbedArea, TabPane } from 'react-bootstrap';

import DomainActions from '../../actions/DomainActions';
import HostingActions from '../../actions/HostingActions';

import DomainTable from '../Domain/Table';
import ServiceTable from './Table';
import WebsiteTable from '../Hosting/WebsiteTable';

function getState() {
  return {
    hasDomains: ClientDomainStore.get().length > 0,
    hasWebsites: ClientWebsiteStore.get().length > 0
  };
}

var ServiceList = React.createClass({
    getInitialState: function () {
        return getState();
    },
    componentDidMount: function() {
        ClientDomainStore.addChangeListener(this._onChange);
        ClientWebsiteStore.addChangeListener(this._onChange);
        UserStore.addChangeListener(this.componentWillMount);
    },
    componentWillMount: function () {
        DomainActions.getDomains();
        HostingActions.getWebsites();
    },
    componentWillUnmount: function () {
        ClientDomainStore.removeChangeListener(this._onChange);
        ClientWebsiteStore.removeChangeListener(this._onChange);
        UserStore.removeChangeListener(this.componentWillMount);
    },
    render: function () {
        const sections = [];

        sections.push(<section key="service-list">
            <h2>Services</h2>

            <ServiceTable widgetName="Services" allowSearch={true} hideSingleBillingGroup={false} showIpAddress={true} showSite={true} />
        </section>);

        const tabs = [];
        if (this.state.hasDomains) {
            tabs.push({
                key: 'domain-list',
                tab: 'Domains',
                h2: 'Domains',
                content: <DomainTable widgetName="Domains" allowSearch={true}/>
            });
        }
        if (this.state.hasWebsites) {
            tabs.push({
                key: 'active-websites',
                tab: 'Websites',
                h2: 'Websites',
                content: <WebsiteTable />
            });
        }

        if (tabs.length === 1) {
            sections.push(<section key={tabs[0].key}>
                <h2>{tabs[0].h2}</h2>
                {tabs[0].content}
            </section>);
        } else if (tabs.length > 1) {
            sections.push(<TabbedArea animation={false} key="tabs">
                {tabs.map(tab => <TabPane key={tab.key} eventKey={tab.key} tab={tab.tab}>{tab.content}</TabPane>)}
            </TabbedArea>);
        }

        return <div>{sections}</div>;
    },
    _onChange: function() {
        this.setState(getState());
    }
});
module.exports = ServiceList;



// WEBPACK FOOTER //
// ./app/components/ClientService/List.js